module.exports = __webpack_public_path__ + "img/Hospitals.13b982fe.jpg";